import { useQuery } from "@tanstack/react-query";

import { CasesApi } from "@/api/client/cases";
import { CaseStatusEnum } from "@/root/types";

const useCaseNumbers = (status?: CaseStatusEnum) => {
  const {
    data: caseNumbers,
    isLoading: getCaseNumbersLoading,
    error: getCaseNumbersError,
  } = useQuery({
    queryKey: ["cases", "caseNumbers", "caseUUIDs", status],
    queryFn: () => CasesApi.getCaseNumbers(status),
  });

  return {
    caseNumbers: caseNumbers || [],
    getCaseNumbersLoading,
    getCaseNumbersError,
  };
};

export default useCaseNumbers;
